import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { catalogUpdateConstructionTypeMutation } from '../catalogConstructionTypesQueries';

interface IUseUpdateConstructionType {
    onSuccessHandler: () => void;
}

export const useUpdateConstructionType = ({ onSuccessHandler }: IUseUpdateConstructionType) => {
    const [updateData, updateStatus, updateError, updateRequest] = useRequest({
        requestId: 'updateConstructionType',
        query: catalogUpdateConstructionTypeMutation,
        withEffect: false,
        dependenciesUpdater: ({ payload }) => {
            if (payload?.catalogUpdateConstructionType?.result) {
                onSuccessHandler();
            }
        },
    });

    const [resetUpdateData] = useResetStoreData({ requestId: 'updateConstructionType' });

    const resetEditData = () => {
        resetUpdateData(null);
    };

    return {
        resetEditData,
        constructionTypeEditData: updateData?.catalogUpdateConstructionType,
        constructionTypeEditStatus: updateStatus,
        constructionTypeEditError: updateError,
        constructionTypeEditRequest: updateRequest,
        isSavingInProgress: updateStatus === RequestStatus.FETCHING,
    };
};
